import { Component, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { FormField } from '@nuso/forms/data-access';

import { BaseFormInput } from '../inputs/base-form-input';

@Component({
    selector: 'nuso-form-control',
    templateUrl: './form-control.component.html',
    styleUrls: ['./form-control.component.css'],
    standalone: false
})
export class FormControlComponent {
  @Input() field: FormField;
  @Output() actionButtonClicked = new EventEmitter<FormField>();
  @Output() fieldClicked = new EventEmitter<FormField>();

  @ViewChild('input', { static: false }) input: BaseFormInput;

  constructor() {}

  focus() {
    if (this.input) {
      this.input.focus();
    }
  }

  get maskedField() {
    return {
      ...this.field,
      attrs: { ...this.field.attrs, style: { 'font-family': 'text-security-disc', '-webkit-text-security': 'disc' } },
    };
  }
}
